import { useState } from "react";
import { BODY_TYPES, trimsFor, trUpper } from "../lib/labels";
import { BRANDS, modelsFor, enginesFor, YEARS, FUEL_TYPES, TRANSMISSIONS, COLORS } from "../lib/vehicleCatalog";

export function SmartSelect({ label, value, onChange, options, testid, inputCls, labelCls,
  placeholder = "Seçiniz", allowManual = true, disabled = false, required = false, manualPlaceholder = "Yazın..." }) {
  const [manual, setManual] = useState(() => !!value && !options.includes(value));
  const showExtra = !!value && !options.includes(value) && !manual;
  return (
    <div>
      <label className={labelCls}>{label}{required ? " *" : ""}</label>
      <select data-testid={testid} value={manual ? "__manual" : (value || "")} disabled={disabled} required={required && !manual}
        onChange={(e) => {
          if (e.target.value === "__manual") { setManual(true); onChange(""); }
          else { setManual(false); onChange(e.target.value); }
        }}
        className={`${inputCls} disabled:opacity-50`}>
        <option value="">{placeholder}</option>
        {options.map((o) => <option key={o} value={o}>{o}</option>)}
        {showExtra && <option value={value}>{value}</option>}
        {allowManual && <option value="__manual">Diğer / Manuel Gir</option>}
      </select>
      {manual && (
        <input data-testid={`${testid}-manual`} value={value || ""} required={required}
          onChange={(e) => onChange(trUpper(e.target.value))}
          className={`${inputCls} mt-2`} placeholder={manualPlaceholder} />
      )}
    </div>
  );
}

export function BrandField({ value, onChange, testid, inputCls, labelCls, required = true }) {
  return <SmartSelect label="Marka" value={value} onChange={onChange} options={BRANDS} testid={testid}
    inputCls={inputCls} labelCls={labelCls} required={required} manualPlaceholder="Marka adını yazın" />;
}

export function ModelField({ brand, value, onChange, testid, inputCls, labelCls, required = true }) {
  return <SmartSelect label="Model" value={value} onChange={onChange} options={modelsFor(brand)} testid={testid}
    inputCls={inputCls} labelCls={labelCls} required={required} manualPlaceholder="Model adını yazın" />;
}

export function YearField({ value, onChange, testid, inputCls, labelCls, required = true }) {
  return <SmartSelect label="Model Yılı" value={String(value || "")} onChange={onChange} options={YEARS}
    testid={testid} inputCls={inputCls} labelCls={labelCls} required={required} allowManual={false} />;
}

export function EngineField({ brand, value, onChange, testid, inputCls, labelCls }) {
  return <SmartSelect label="Motor" value={value} onChange={onChange} options={enginesFor(brand)} testid={testid}
    inputCls={inputCls} labelCls={labelCls} manualPlaceholder="örn. 1.6 TDCI" />;
}

export function FuelField({ value, onChange, testid, inputCls, labelCls }) {
  return <SmartSelect label="Yakıt Tipi" value={value} onChange={onChange} options={FUEL_TYPES}
    testid={testid} inputCls={inputCls} labelCls={labelCls} allowManual={false} />;
}

export function TransmissionField({ value, onChange, testid, inputCls, labelCls }) {
  return <SmartSelect label="Vites" value={value} onChange={onChange} options={TRANSMISSIONS}
    testid={testid} inputCls={inputCls} labelCls={labelCls} allowManual={false} />;
}

export function ColorField({ value, onChange, testid, inputCls, labelCls }) {
  return <SmartSelect label="Renk" value={value} onChange={onChange} options={COLORS}
    testid={testid} inputCls={inputCls} labelCls={labelCls} manualPlaceholder="Rengi yazın" />;
}

export function BodyTypeField({ value, onChange, testid, inputCls, labelCls }) {
  return <SmartSelect label="Kasa Tipi" value={value} onChange={onChange} options={BODY_TYPES}
    testid={testid} inputCls={inputCls} labelCls={labelCls} allowManual={false} />;
}

export function TrimField({ brand, value, onChange, testid, inputCls, labelCls }) {
  return <SmartSelect label="Araç Paketi" value={value} onChange={onChange} options={trimsFor(brand)}
    testid={testid} inputCls={inputCls} labelCls={labelCls} manualPlaceholder="Paket adını yazın (örn. TITANIUM PLUS)" />;
}
